/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Toast_BodyInputs */

const en_invite_toast_body = /** @type {(inputs: Invite_Toast_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing was signed in and the invite is still open.`)
};

/** @type {(inputs: Invite_Toast_BodyInputs) => LocalizedString} */
const ar_invite_toast_body = en_invite_toast_body;

/** @type {(inputs: Invite_Toast_BodyInputs) => LocalizedString} */
const he_invite_toast_body = en_invite_toast_body;

/** @type {(inputs: Invite_Toast_BodyInputs) => LocalizedString} */
const ur_invite_toast_body = en_invite_toast_body;

/** @type {(inputs: Invite_Toast_BodyInputs) => LocalizedString} */
const es_invite_toast_body = en_invite_toast_body;

/** @type {(inputs: Invite_Toast_BodyInputs) => LocalizedString} */
const fr_invite_toast_body = en_invite_toast_body;

/** @type {(inputs: Invite_Toast_BodyInputs) => LocalizedString} */
const de_invite_toast_body = en_invite_toast_body;

/** @type {(inputs: Invite_Toast_BodyInputs) => LocalizedString} */
const pt_invite_toast_body = en_invite_toast_body;

/** @type {(inputs: Invite_Toast_BodyInputs) => LocalizedString} */
const hi_invite_toast_body = en_invite_toast_body;

/** @type {(inputs: Invite_Toast_BodyInputs) => LocalizedString} */
const bn_invite_toast_body = en_invite_toast_body;

/**
* | output |
* | --- |
* | "Nothing was signed in and the invite is still open." |
*
* @param {Invite_Toast_BodyInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_toast_body = /** @type {((inputs?: Invite_Toast_BodyInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Toast_BodyInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_toast_body(inputs)
	if (locale === "he") return he_invite_toast_body(inputs)
	if (locale === "ur") return ur_invite_toast_body(inputs)
	if (locale === "es") return es_invite_toast_body(inputs)
	if (locale === "fr") return fr_invite_toast_body(inputs)
	if (locale === "de") return de_invite_toast_body(inputs)
	if (locale === "pt") return pt_invite_toast_body(inputs)
	if (locale === "hi") return hi_invite_toast_body(inputs)
	if (locale === "bn") return bn_invite_toast_body(inputs)
	return /** @type {LocalizedString} */ ("Nothing was signed in and the invite is still open.")
});